<template>
    <h1>{{ title }}</h1>

    <CustomElementOne
        :string="'Dit is een string'"
        :integer="123"
        :boolean="true"
        :test="{ object: true }"
    ></CustomElementOne>

    <hr>

    <div class="container" ref="container1">
        <div ref="panzoom">
            <div class="container__inner" ref="containerContent1">

                <div v-for="index in [0, 1]" ref="table" class="drag-container">
                    <h2>{{ tables[index].title }}</h2>
                    <div class="drag-container__inner"
                         @drop="addToTable($event, tables[index])"
                         @dragover.prevent
                         @dragenter.prevent=""
                    >
                        <div v-for="reservation in getReservationsForTable(tables[index].id)"
                             class="draggable"
                             :draggable=" ! selectModeActive || (selectModeActive && activeReservationId == reservation.id)"
                             :class="{
                                 'draggable--selectable': ! selectModeActive || (selectModeActive && activeReservationId == reservation.id),
                                 'no-display': activeDraggingChip == reservation.chipId
                             }"
                             :data-reservation-id="reservation.id"
                             :data-reservation-chip="reservation.chipId"

                             @dragstart="startDrag($event, reservation)"
                             @dragend="endDrag"
                             @click.prevent="enterSelectMode($event, reservation)"
                             @mouseover="disablePanning"
                             @mouseleave="enablePanning"
                        >
                            {{ reservation.title }} ({{ reservation.quantity }})
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container" ref="container2">
        <div ref="panzoom2">
            <div class="container__inner" ref="containerContent2">

                <div v-for="index in [2, 3]" ref="table" class="drag-container">
                    <h2>{{ tables[index].title }}</h2>
                    <div class="drag-container__inner"
                         @drop="addToTable($event, tables[index])"
                         @dragover.prevent
                         @dragenter.prevent=""
                    >
                        <div v-for="reservation in getReservationsForTable(tables[index].id)"
                             class="draggable"
                             :draggable=" ! selectModeActive || (selectModeActive && activeReservationId == reservation.id)"
                             :class="{
                                 'draggable--selectable': ! selectModeActive || (selectModeActive && activeReservationId == reservation.id),
                                 'no-display': activeDraggingChip == reservation.chipId
                             }"                             :data-reservation-chip="reservation.chipId"
                             :data-reservation-id="reservation.id"

                             @dragstart="startDrag($event, reservation)"
                             @dragend="endDrag"
                             @click.prevent="enterSelectMode($event, reservation)"
                             @mouseover="disablePanning"
                             @mouseleave="enablePanning"
                        >
                            {{ reservation.title }} ({{ reservation.quantity }})
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomElementOne from './custom-components/custom-component-one.ce';
import { enableDragDropTouch } from "./vendor/drag-drop-touch.esm.min.js";

import panzoom from 'panzoom';

export default {
    components: {
        CustomElementOne
    },
    data() {
        return {
            title: 'Main Element',
            container: null,
            container2: null,
            containerWidth: null,
            containerContentWidth: null,
            zoomFactor: 1,
            tableAmount: 3,

            sortable: null,

            activeDraggingChip: null,

            tables: [
                {
                    title: 'Tafel 1',
                    id: 'table-1',
                    quantity: 9,
                },
                {
                    title: 'Tafel 2',
                    id: 'table-2',
                    quantity: 2,
                },
                {
                    title: 'Tafel 3',
                    id: 'table-3',
                    quantity: 4,
                },
                {
                    title: 'Tafel 4',
                    id: 'table-4',
                    quantity: 4,
                },
            ],

            reservations: [
                {
                    id: 1,
                    title: 'Reservatie 1',
                    tableId: 'table-1',
                    chipId: 1,
                    quantity: 9,
                },
                {
                    id: 2,
                    title: 'Reservatie 2',
                    tableId: 'table-1',
                    chipId: 2,
                    quantity: 2,
                },
                {
                    id: 3,
                    title: 'Reservatie 3',
                    tableId: 'table-2',
                    chipId: 3,
                    quantity: 4,
                },
                {
                    id: 3,
                    title: 'Reservatie 3',
                    tableId: 'table-3',
                    chipId: 4,
                    quantity: 4,
                },
            ],

            selectModeActive: false,
            activeReservationId: null,
        }
    },
    watch: {
        selectModeActive() {
            if (this.selectModeActive) {
                return;
            }
        }
    },
    methods: {

        enterSelectMode(e, reservation) {
            if (this.selectModeActive) {
                this.activeReservationId = null;
                this.selectModeActive = false;
                return;
            }

            this.activeReservationId = reservation.id;
            this.selectModeActive = true;
        },

        getReservationsForTable(tableId) {
            return this.reservations.filter(reservation => reservation.tableId === tableId);
        },

        addToTable(e, table) {
            e.stopPropagation();
            e.preventDefault();

            const reservationId = e.dataTransfer.getData('reservationId');
            const reservationChipId = e.dataTransfer.getData('reservationChipId');
            const item = this.reservations.find(reservation => reservation.id == reservationId && reservation.chipId == reservationChipId);
            item.tableId = table.id;

            if ( ! this.selectModeActive) {
                this.enablePanning();
            }

            this.$nextTick(() => {
                const $element = document.querySelector(`[data-reservation-chip="${reservationChipId}"]`);
                this.addDragAndDropPolyfillToDraggableElement($element);
                this.activeDraggingChip = null;
            })
        },

        disablePanning() {
            this.container.pause();
            this.container2.pause();
        },

        enablePanning() {
            this.container.resume();
            this.container2.resume();
        },

        startDrag(e, reservation) {
            this.disablePanning();
            e.dataTransfer.dropEffect = 'move'
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData('reservationId', reservation.id);
            e.dataTransfer.setData('reservationChipId', reservation.chipId);

            this.activeDraggingChip = reservation.chipId;
        },

        endDrag() {
            this.activeDraggingChip = null;
            if (this.selectModeActive) {
                return;
            }

            this.enablePanning();
        },

        addDragAndDropPolyfillToDraggableElement(element) {
            enableDragDropTouch(element, document, {
                isPressHoldMode: true
            });
        },
    },
    mounted() {
        this.container = panzoom(this.$refs.panzoom, {
            beforeWheel: (e) => {
                const ignore = ! e.shiftKey;
                return ignore;
            },
            onTouch: (e) => {
                // if (e.target.dataset.reservationId) {
                //     this.disablePanning();
                //     return false;
                // }

                if (e.targetTouches.length >= 2) {
                    this.enablePanning();
                    return true;
                }

                this.disablePanning();
                return false;
            }
        });
        this.container.pause();

        this.container2 = panzoom(this.$refs.panzoom2, {
            beforeWheel: function(e) {
                // allow wheel-zoom only if altKey is down. Otherwise - ignore
                var shouldIgnore = !e.shiftKey;
                return shouldIgnore;
            },
            onTouch: (e) => {
                if (e.targetTouches.length >= 2) {
                    this.enablePanning();
                    return true;
                }

                this.disablePanning();
                return false;
            }
        });
        this.container2.pause();

        document.querySelectorAll('[data-reservation-chip]').forEach((element) => {
            this.addDragAndDropPolyfillToDraggableElement(element);
        });
    }
}
</script>